import { render } from "./PerformanceView.vue?vue&type=template&id=3d2ff2e3&scoped=true&ts=true"
import script from "./PerformanceView.vue?vue&type=script&lang=ts"
export * from "./PerformanceView.vue?vue&type=script&lang=ts"

import "./PerformanceView.vue?vue&type=style&index=0&id=3d2ff2e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2ff2e3"]])

export default __exports__